/* ==========================================================================
   Timo Wolfinger – Kartenbilder / Hover-Zweitbild
   Die Canvas-Normalisierung bleibt DEAKTIVIERT (Fix 2026-07-18, ersetzt durch
   die reine CSS-Loesung in tw-cards.css: Creme-Hintergrund + mix-blend-mode:
   multiply). Diese Datei steuert jetzt nur noch den Hover-Bildwechsel:

   1. Geladene Zweitbilder (.tw-card__img img.alt) bekommen die Klasse .ready.
      Erst dann blendet der Hover das Zweitbild ein und das Hauptbild aus
      (CSS :has(img.alt.ready)) – so blitzt NIE ein leerer Rahmen auf.
   2. Zweitbilder sind loading="lazy". Beim ersten mouseenter einer Karte wird
      das jeweilige Zweitbild sofort geladen (loading=eager), damit der Wechsel
      auch beim ersten Hover sitzt. Karten ohne Zweitbild bleiben unveraendert.
   Portiert aus shop-preview.html (.product-card__img img.alt.ready).
   ========================================================================== */
(function () {
  'use strict';

  function markReady(img) {
    if (!img) return;
    if (img.classList.contains('ready')) return;
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('ready');
    } else {
      img.addEventListener('load', function () { img.classList.add('ready'); }, { once: true });
    }
  }

  function primeAlt(img) {
    if (!img) return;
    if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    markReady(img);
  }

  function bindCard(card) {
    if (card.dataset.twHover) return;
    card.dataset.twHover = '1';
    var alt = card.querySelector('.tw-card__img img.alt');
    if (!alt) return;                 /* kein Zweitbild -> nichts zu tun */
    markReady(alt);                    /* falls schon geladen */
    card.addEventListener('mouseenter', function () { primeAlt(alt); }, { once: true });
    /* Touch: beim ersten Antippen ebenfalls vorladen */
    card.addEventListener('touchstart', function () { primeAlt(alt); }, { once: true, passive: true });
  }

  function scan() {
    var cards = document.querySelectorAll('.tw-card');
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
  }

  function init() {
    scan();
    if ('MutationObserver' in window) {
      new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
